module.exports = __webpack_public_path__ + "img/cca-jquery-level-1.8cd96ef2.png";